import { createStore } from 'vuex'
import ConfigModule from '@/store/modules/ConfigModule'
import ThemeModeModule from '@/store/modules/ThemeModeModule'
import BodyModule from '@/store/modules/BodyModule'
import UserModule from '@/store/modules/UserModule'

const store = createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    ConfigModule,
    ThemeModeModule,
    BodyModule,
    UserModule
  }
})

export default store
